"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const PlayArrowRounded_1 = __importDefault(require("@mui/icons-material/PlayArrowRounded"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ArrowPositive = (0, styled_components_1.default)(PlayArrowRounded_1.default) `color: green; transform: rotate(270deg); height: 20px !important;  width: 20px !important;`;
const ArrowNegative = (0, styled_components_1.default)(PlayArrowRounded_1.default) `color: red;  transform: rotate(90deg); height: 20px !important;  width: 20px !important;`;
const ValueText = styled_components_1.default.span `text-align: right; color: #222;`;
const ValueFieldWrapper = styled_components_1.default.div `position: relative; display: inline-block; white-space: nowrap;`;
const ValueField = (props) => {
    const { formatAmount } = (0, useQCurrency_1.default)();
    const { inputValue, color, type, valueChange, useParentheses, useTwoLines, fontSize = 12, style = {} } = props;
    const value = (inputValue === undefined || inputValue === null) ? 'N/A' : inputValue;
    const percent = (type === 'percentage') ? '%' : '';
    const marginRight = percent ? '-4px' : '0';
    const valueChangeFormatted = valueChange ? formatAmount(valueChange, 'USD') : '';
    const valueFormatted = ((type === 'percentage') ? (`${formatAmount(value, '')}${percent}`) : (`${formatAmount(value, 'USD')}${percent}`));
    const variant = color === 'sign' ? 'body1' : 'body2';
    const valueFormattedParenthesized = (`(${formatAmount(value, '')}%)`);
    if (value === 'N/A') {
        return (type === 'percentage'
            ? (<div />)
            : (<ValueText>{value}{percent}</ValueText>));
    }
    let theColor = '#222';
    if (color === 'sign') {
        if (value === 0) {
            theColor = '#222';
        }
        else if (value < 0) {
            theColor = '#e12b3d';
        }
        else {
            theColor = '#04903b';
        }
    }
    return (<ValueFieldWrapper style={(Object.assign(Object.assign({}, style), { marginRight }))}>
      <Typography_1.default variant={variant} style={{ color: theColor, display: 'inline-block', fontWeight: 500, fontSize: `${fontSize}px` }}>
        {valueChangeFormatted}{(useTwoLines ? <br /> : ' ')}{(useParentheses ? valueFormattedParenthesized : valueFormatted)}
      </Typography_1.default>
      {type === 'percentage' && value < 0 &&
            <ArrowNegative />}
      {type === 'percentage' && value > 0 &&
            <ArrowPositive />}
    </ValueFieldWrapper>);
};
exports.default = ValueField;
